import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import './Footer.scss'
import 'react-toastify/dist/ReactToastify.css'
import { getStringByTextKey } from '@/utils/getStringByTextKey'
import JoinPolicyModal from '@/containers/JoinPolicy'
import MsgModalModal from '@/components/Console/Modal/MsgModal'
import { getLanguage, localStrings } from '@/utils/localization'

@inject('store')
@observer
export default class FooterComponent extends Component {
  state = {
    showPolicy: false,
    tabTarget: 'tab1',
    showMsgModal: false,
    msgModalTitle: '',
    msgModalBody: ''
  }

  render() {
    const {
      showPolicy,
      tabTarget,
      showMsgModal,
      msgModalTitle,
      msgModalBody
    } = this.state
    const lang = localStrings.getLanguage()
    const nextButton = () => {
      const state = { ...this.state }
      state['showMsgModal'] = false
      this.setState(state)
      window.location.href = `${process.env.PUBLIC_URL}/${lang}/login?step=true`
    }
    const hideModal = () => {
      this.setState({
        showPolicy: false
      })
    }
    const openTermsService = () => {
      console.log('openTermsService')
      this.setState({
        ...this.state,
        showPolicy: true,
        tabTarget: 'tab1'
      })
    }
    const openPrivatePolicy = () => {
      console.log('openPrivatePolicy')
      this.setState({
        ...this.state,
        showPolicy: true,
        tabTarget: 'tab2'
      })
    }
    const openPaidTermsService = () => {
      console.log('openPaidTermsService')
      this.setState({
        ...this.state,
        showPolicy: true,
        tabTarget: 'tab3'
      })
    }
    const changeLanguage = () => {
      lang === 'ko'
        ? localStrings.setLanguage('en')
        : localStrings.setLanguage('ko')

      window.location.reload()
    }
    const goToBlog = () => {
      window.location.href = `https://blog.naver.com/fs0608`
    }
    const goToYoutube = () => {
      window.location.href = `https://www.youtube.com/user/FasooMarcom`
    }
    const goToFacebook = () => {
      window.location.href = `https://ko-kr.facebook.com/fasoo.korea/`
    }
    const goToInsta = () => {
      window.location.href = `https://www.instagram.com/fasoo_official/`
    }
    const YEAR = new Date().getFullYear()
    const languageCode = localStrings.getLanguage()
    return (
      <footer className="footer">
        <section className="footer-menu">
          <div className="footer-menu-left">
            <ul>
              <li>{`ⓒ ${YEAR} Fasoo`}</li>
              <li onClick={openTermsService}>
                {getStringByTextKey('logIn.signUp.agreement2')}
              </li>
              <li onClick={openPrivatePolicy}>
                {getStringByTextKey('logIn.signUp.agreement4')}
              </li>
              {/* <li>유료 이용약관</li> */}
            </ul>
          </div>
          {languageCode === 'ko' && (
            <div className="footer-menu-right">
              <ul>
                {/* <li>
                  <img className="internetIcon" onClick={changeLanguage} />
                </li> */}
                <li>
                  <div className="blogIcon" onClick={goToBlog} />
                </li>
                <li>
                  <div className="youtubeIcon" onClick={goToYoutube} />
                </li>
                <li>
                  <div className="facebookIcon" onClick={goToFacebook} />
                </li>
                <li>
                  <div className="instaIcon" onClick={goToInsta} />
                </li>
              </ul>
            </div>
          )}
        </section>
        {languageCode === 'ko' && (
          <section className="footer-description">
            <p>주식회사 파수 | 대표이사 조규곤 | 사업자등록번호 1208606582</p>
            <p>
              주소 : 서울특별시 마포구 월드컵북로 396 (상암동 1605, 누리꿈스퀘어
              비즈니스타워 17층) 03925 | 전화번호: 02-300-9261 |
              전자우편주소:cloud@fasoo.com
            </p>
          </section>
        )}
        {showPolicy && (
          <JoinPolicyModal
            showPolicy={showPolicy}
            hideModal={hideModal}
            tabTarget={tabTarget}
            openTermsService={openTermsService}
            openPrivatePolicy={openPrivatePolicy}
            openPaidTermsService={openPaidTermsService}
          />
        )}
        {/* {showMsgModal && (
          <MsgModalModal
            msgModalTitle={msgModalTitle}
            msgModalBody={msgModalBody}
            showMsgModal={showMsgModal}
            nextButton={nextButton}
          />
        )} */}
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.js